import React, {useState, useCallback} from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Accordion from '../../../../../BaseComponentWrappers/MotifAccordion';
import RiskFactorList from '../Common/RiskFactors/RiskFactorList';

function RelateRiskFactorHeaderListItem({engagementId, headerId, bodyId, headerName, riskFactorsList, isDisabled}) {
	const [isAccordionOpen, setIsAccordionOpen] = useState(true); //Each item should be expanded by default

	const dummyCallback = useCallback((evt) => {}, []);

	return (
		<StyledRelateRiskFactorHeaderListItem className="StyledRelateRiskFactorHeaderListItem">
			<StyledHeaderAccordion
				open={isAccordionOpen}
				onOpen={dummyCallback}
				onClose={dummyCallback}
				onClick={(e) => setIsAccordionOpen(!isAccordionOpen)}
				accordionHeading={headerName}
				stopPropagation
				className="relate-risk-factor-accordion"
				useChevronIcon={true}
			>
				<RiskFactorList
					engagementId={engagementId}
					headerId={headerId}
					bodyId={bodyId}
					riskFactorsList={riskFactorsList}
					isDisabled={isDisabled}
				/>
			</StyledHeaderAccordion>
		</StyledRelateRiskFactorHeaderListItem>
	);
}

RelateRiskFactorHeaderListItem.proppTypes = {
	engagementId: PropTypes.number,
	headerId: PropTypes.number,
	headerName: PropTypes.string,
	bodyId: PropTypes.number,
	riskFactorsList: PropTypes.arrayOf(PropTypes.number)
};

const StyledRelateRiskFactorHeaderListItem = styled.section`
	margin-bottom: var(--px-40);
	cursor: default;
	&:last-child {
		margin-bottom: 0;
	}
`;

const StyledHeaderAccordion = styled(Accordion)`
	.motif-accordion-content {
		.riskfactorslist-column-titles {
			border-bottom: 0;
			padding-bottom: 0;
		}
		.column-relate-riskfactor {
			padding-right: var(--px-15);
		}
		.StyledRiskFactorListItem {
			padding: 0;
			.risk-factor-name-container {
				word-break: break-word;
			}
			.related-risk-container {
				.motif-inline-message {
					.motif-inline-message-content svg {
						fill: var(--red-600);
						width: var(--px-20);
						height: var(--px-20);
					}
				}
			}
			.risk-desc-container {
				.risk-type-container {
					.newrisk-btn {
						border-bottom-left-radius: var(--px-8);
						border-bottom-right-radius: var(--px-8);
					}
				}
				&.long-desc-container {
					flex-direction: column;
				}
			}
			.rationale-textarea-container {
				&.warning-msg,
				&.text-area {
					margin-left: 0;
					width: 95%;
				}
				.column-risk-type {
					width: 100%;
					margin-bottom: var(--px-4);
					padding-left: 0 !important;
				}
			}
			.related-risk-container,
			.risk-type-container {
				.motif-inline-message-content {
					align-items: center;
					svg {
						width: var(--px-20);
						height: var(--px-20);
						margin-right: var(--px-5);
					}
				}
			}
		}
		.StyledGrayFadeProgressBar {
			display: flex;
			align-items: center;
			justify-content: center;
			padding-bottom: var(--px-16);
			.motif-progress-bar-wrapper {
				position: absolute;
				.motif-progress-bar {
					width: var(--px-20);
					height: var(--px-20);
				}
			}
			.children-body {
				width: 100%;
			}
		}
		.rationale-textarea-container {
			flex-direction: column;
			position: relative;
			margin-top: var(--px-24);
			.canvas-form-textarea {
				width: calc(100% - var(--px-90)) !important;
				height: var(--px-94) !important;
				flex-direction: column;
				.StyledCanvasFormInputDisplay {
					height: var(--px-94) !important;
				}
				&.aresStyledCanvasFormTextAreaEditing {
					height: var(--px-114) !important;
				}
			}
			.column-risk-type {
				font-size: var(--px-14);
				font-weight: 400;
				line-height: var(--px-20);
				color: var(--neutrals-700);
				margin-bottom: var(--px-4);
			}
			.pull-right-counter {
				font-size: var(--px-12);
				font-weight: 300;
				line-height: var(--px-18);
				color: var(--neutrals-700) !important;
				display: inline-flex;
				justify-content: flex-end;
			}
			&.warning-msg {
				height: var(--px-20);
				margin-bottom: 0;
				margin-top: var(--px-6) !important;
				svg {
					width: var(--px-20);
					height: var(--px-20);
					margin-right: var(--px-5);
				}
			}
		}
	}
`;

export default RelateRiskFactorHeaderListItem;
